import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent } from './ng-select.component';

@NgModule({
  declarations: [NgSelectComponent],
  imports: [CommonModule, FormsModule],
  exports: [NgSelectComponent],
})
export class NgSelectCompatModule { }
